<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 本地默认控制 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control1") }}</span>
                <div class="main" v-loading="loading">
                    <p>
                        <el-button @click="tan_loacl_default()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control9") }}</el-button>
                        <el-alert :title="this.load_hind1" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="TYPE" :label="$t('logs.control10')">
                            </el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.control11')">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up1" v-show="tanchu" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.control9')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大邮件数 -->
                                    {{this.default_local2}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大收件人数 -->
                                    {{this.default_local1}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大大站点收信人数 -->
                                    {{this.default_local3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderBsRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大邮件数 -->
                                    {{this.default_local4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大收件人数 -->
                                    {{this.default_local5}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大大站点收信人数 -->
                                    {{this.default_local6}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderBsRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大字节数 -->
                                    {{this.default_local7}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutBytes_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大字节数 -->
                                    {{this.default_local8}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutBytes_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大邮件数 -->
                                    {{this.default_local9}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestMsg" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大收件人数 -->
                                    {{this.default_local10}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestRcpt" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大大站点数 -->
                                    {{this.default_local11}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestBsRcpt" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地域24小时最大收件人数 -->
                                    {{this.default_local12}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxSenderOutRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地域24小时最大邮件数 -->
                                    {{this.default_local13}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxSenderOutMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地域24小时最大给大站点邮件数 -->
                                    {{this.default_local14}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxSenderBsRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地域24小时最大允许字节数 -->
                                    {{this.default_local15}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxSenderOutBytes_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户单封邮件最大收件人数量 -->
                                    {{this.default_local16}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="rcptnum" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_loacl_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_loacl_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 外部默认控制 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control2") }}</span>
                <div class="main" v-loading="loading">
                    <p>
                        <el-button @click="tan_outside_default()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control12") }}</el-button>
                        <el-alert :title="this.load_hind2" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_outside" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="TYPE" :label="$t('logs.control10')">
                            </el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.control11')">
                            </el-table-column>

                        </el-table>
                    </div>
                    <div class="pop-up pop-up1" v-show="tanchu" v-loading="loading" v-drag="{ handle: '.pop_up_text_Upload' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_Upload"><span class="span_pad"></span> {{$t('logs.control12')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户24小时最大邮件数 -->
                                    {{this.default_outside1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户24小时最大收件人数 -->
                                    {{this.default_outside2}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户1小时最大邮件数 -->
                                    {{this.default_outside3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户1小时最大收件人数: -->
                                    {{this.default_outside4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部单域24小时最大邮件数 -->
                                    {{this.default_outside5}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxForeignMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部单域24小时最大收件人数 -->
                                    {{this.default_outside6}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxForeignRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部单域1小时最大邮件数 -->
                                    {{this.default_outside7}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxForeignMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部单域1小时最大收件人数 -->
                                    {{this.default_outside8}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="DomainMaxForeignRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户单邮件最大收件人数量 -->
                                    {{this.default_outside9}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="Foreignrcptnum" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_outside_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_outside_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- IP默认控制 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control3") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_ip_default()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control13") }}</el-button>
                        <el-alert :title="this.load_hind3" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_ip" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="TYPE" :label="$t('logs.control10')">
                            </el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.control11')">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up2" v-show="tanchu" v-drag="{ handle: '.pop_up_text_addip' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_addip"><span class="span_pad"></span> {{$t('logs.control13')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大连接数 -->
                                    {{this.default_ip1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpConn_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大邮件数 -->
                                    {{this.default_ip2}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大收件人数 -->
                                    {{this.default_ip3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大连接数: -->
                                    {{this.default_ip4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpConn_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大邮件数 -->
                                    {{this.default_ip5}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大收件人数 -->
                                    {{this.default_ip6}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 本地控制 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control4") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_loacl_default()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control14") }}</el-button>
                        <el-alert :title="this.load_hind4" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_local_a" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>
                            <el-table-column prop="LOCALEMAIL" label="Email">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="120">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_loacl_default(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>
                                    <!-- 编辑 -->

                                    <el-button type="text" size="small" @click="edit_loacl_default(scope.$index, scope.row)" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up1" v-show="tanchu" v-drag="{ handle: '.pop_up_text_relay_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain"><span class="span_pad"></span> {{$t('logs.control14')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大邮件数 -->
                                    {{this.default_local1}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大收件人数 -->
                                    {{this.default_local2}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大大站点收信人数 -->
                                    {{this.default_local3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderBsRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大邮件数 -->
                                    {{this.default_local4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大收件人数 -->
                                    {{this.default_local5}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大大站点收信人数 -->
                                    {{this.default_local6}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderBsRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大邮件数 -->
                                    {{this.default_local9}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestMsg" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大收件人数 -->
                                    {{this.default_local10}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestRcpt" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大大站点数 -->
                                    {{this.default_local11}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestBsRcpt" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户单封邮件最大收件人数量 -->
                                    {{this.default_local16}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="rcptnum" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_loacl1_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_loacl_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up pop-up1" v-show="tanchu_edit" v-loading="loading" v-drag="{ handle: '.pop_up_text_relay_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain_edit"><span class="span_pad"></span> {{$t('logs.control14_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.email}}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大邮件数 -->
                                    {{this.default_local1}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大收件人数 -->
                                    {{this.default_local2}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户24小时外发最大大站点收信人数 -->
                                    {{this.default_local3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderBsRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大邮件数 -->
                                    {{this.default_local4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大收件人数 -->
                                    {{this.default_local5}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderOutRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户1小时外发最大大站点收信人数 -->
                                    {{this.default_local6}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderBsRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大邮件数 -->
                                    {{this.default_local9}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestMsg" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大收件人数 -->
                                    {{this.default_local10}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestRcpt" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户相同内容邮件最大大站点数 -->
                                    {{this.default_local11}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxSenderDigestBsRcpt" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 本地账户单封邮件最大收件人数量 -->
                                    {{this.default_local16}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="rcptnum" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_loacl1_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_loacl_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- 外部控制 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control5") }}</span>
                <div class="main" v-loading="loading">
                    <p>
                        <el-button @click="tan_outside_default()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control15") }}</el-button>
                        <el-alert :title="this.load_hind5" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_out_a" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>
                            <el-table-column prop="OUTEMAIL" label="Email">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="120">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_out_default(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>
                                    <!-- 编辑 -->

                                    <el-button type="text" size="small" @click="edit_out_default(scope.$index, scope.row)" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up2" v-show="tanchu" v-drag="{ handle: '.pop_up_text_local_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span> {{$t('logs.control15')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户24小时最大邮件数 -->
                                    {{this.default_outside1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户24小时最大收件人数 -->
                                    {{this.default_outside2}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户1小时最大邮件数 -->
                                    {{this.default_outside3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户1小时最大收件人数: -->
                                    {{this.default_outside4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户单邮件最大收件人数量 -->
                                    {{this.default_outside9}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="Foreignrcptnum" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_outside1_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_outside_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up pop-up2" v-show="tanchu_edit" v-loading="loading" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.control15_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.email}}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户24小时最大邮件数 -->
                                    {{this.default_outside1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户24小时最大收件人数 -->
                                    {{this.default_outside2}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户1小时最大邮件数 -->
                                    {{this.default_outside3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户1小时最大收件人数: -->
                                    {{this.default_outside4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxForeignRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外部账户单邮件最大收件人数量 -->
                                    {{this.default_outside9}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="Foreignrcptnum" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_out1_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_out_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- IP控制 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control6") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_ip_default()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control16") }}</el-button>
                        <el-alert :title="this.load_hind6" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_ip_a" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="SHOW_IP" :label="$t('logs.manage3')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_ip_default(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>
                                    <!-- 编辑 -->

                                    <el-button type="text" size="small" @click="edit_ip_default(scope.$index, scope.row)" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up2" v-show="tanchu" v-loading="loading" v-drag="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.control16')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">

                                    IP :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="ip" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大连接数 -->
                                    {{this.default_ip1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpConn_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大邮件数 -->
                                    {{this.default_ip2}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大收件人数 -->
                                    {{this.default_ip3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大连接数: -->
                                    {{this.default_ip4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpConn_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大邮件数 -->
                                    {{this.default_ip5}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大收件人数 -->
                                    {{this.default_ip6}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip1_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up pop-up2" v-show="tanchu_edit"  v-loading="loading" v-drag="{ handle: '.pop_up_text_ipcor_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor_edit"><span class="span_pad"></span> {{$t('logs.control16_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">

                                    IP :
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.ip}}</span>

                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大连接数 -->
                                    {{this.default_ip1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpConn_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大邮件数 -->
                                    {{this.default_ip2}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpMsg_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 24小时IP最大收件人数 -->
                                    {{this.default_ip3}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpRcpt_24" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大连接数: -->
                                    {{this.default_ip4}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpConn_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大邮件数 -->
                                    {{this.default_ip5}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpMsg_1" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 1小时IP最大收件人数 -->
                                    {{this.default_ip6}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="MaxIpRcpt_1" placeholder=""></el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_ip_default()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_ip_default()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- 禁止用户发信 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control7") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_ban_user()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control17") }}</el-button>
                        <el-alert :title="this.load_hind7" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_base_user" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="PREBL" label="Email">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_base_user_default(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_url_b' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_url_b"><span class="span_pad"></span> {{$t('logs.control17')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ban_user()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ban_user()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 禁止IP发信 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.control8") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_ban_ip()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.control18") }}</el-button>
                        <el-alert :title="this.load_hind8" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_base_ip" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="IPPREBL" :label="$t('logs.manage3')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_base_ip_default(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_url_w' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_url_w"><span class="span_pad"></span> {{$t('logs.control18')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    IP:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="ip" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ban_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ban_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
               <!-- smtp频率管控 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.frequency1") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_smtp_ip()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.frequency1_add") }}</el-button>
                        <el-alert :title="this.load_hind9" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_smtp_ip" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="IP" :label="$t('logs.manage3')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_base_smtp_default(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_import_iup' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_import_iup"><span class="span_pad"></span> {{$t('logs.frequency1_add')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    IP:
                                </div>
                                <div class="block block1">
                                  <el-input style="margin:10px 0"
  type="textarea"
  :autosize="{ minRows: 4, maxRows: 6}"
  placeholder="每行一个或用逗号隔开"
  v-model="ip_smtp">
  
</el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_smtp_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ban_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            ip_smtp:'',
            loading: false,
            load_hind1: "",
            load_hind2: "",
            load_hind3: "",
            load_hind4: "",
            load_hind5: "",
            load_hind6: "",
            load_hind7: "",
            load_hind8: "",
            load_hind9: "",
            fileList_outside: [],
            fileList_ip: [],
            fileList_local_a: [],
            fileList_out_a: [],
            fileList_ip_a: [],
            fileList_base_user: [],
            fileList_base_ip: [],
            fileList_smtp_ip: [],
          
            ip: '',
            email: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            load_dataok: '',
            load_dataok2: '',
            load_dataok3: '',
            load_dataok4: '',
            load_dataok5: '',
            load_dataok6: '',
            load_dataok7: '',
            load_dataok8: '',
            load_dataok9: '',
            tanchu_edit: false,
            // 本地控制
            default_local1: '',
            default_local2: '',
            default_local3: '',
            default_local4: '',
            default_local5: '',
            default_local6: '',
            default_local7: '',
            default_local8: '',
            default_local9: '',
            default_local10: '',
            default_local11: '',
            default_local12: '',
            default_local13: '',
            default_local14: '',
            default_local15: '',
            default_local16: '',
            DomainMaxSenderBsRcpt_24: '',
            DomainMaxSenderOutBytes_24: '',
            DomainMaxSenderOutMsg_24: '',
            DomainMaxSenderOutRcpt_24: '',
            MaxSenderBsRcpt_1: '',
            MaxSenderBsRcpt_24: '',
            MaxSenderDigestBsRcpt: '',
            MaxSenderDigestMsg: '',
            MaxSenderDigestRcpt: '',
            MaxSenderOutBytes_1: '',
            MaxSenderOutBytes_24: '',
            MaxSenderOutMsg_1: '',
            MaxSenderOutMsg_24: '',
            MaxSenderOutRcpt_1: '',
            MaxSenderOutRcpt_24: '',
            rcptnum: '',
            // 外部默认控制
            default_outside9: '',
            default_outside8: '',
            default_outside7: '',
            default_outside6: '',
            default_outside5: '',
            default_outside4: '',
            default_outside3: '',
            default_outside2: '',
            default_outside1: '',
            Foreignrcptnum: '',
            DomainMaxForeignRcpt_1: '',
            DomainMaxForeignMsg_1: '',
            DomainMaxForeignRcpt_24: '',
            DomainMaxForeignMsg_24: '',
            MaxForeignRcpt_1: '',
            MaxForeignMsg_1: '',
            MaxForeignRcpt_24: '',
            MaxForeignMsg_24: '',
            // IP默认控制
            default_ip1: '',
            default_ip2: '',
            default_ip3: '',
            default_ip4: '',
            default_ip5: '',
            default_ip6: '',
            MaxIpConn_24: '',
            MaxIpMsg_24: '',
            MaxIpRcpt_24: '',
            MaxIpConn_1: '',
            MaxIpMsg_1: '',
            MaxIpRcpt_1: '',
        };
    },
    mounted() {
        this.getFileList()
        this.getFileList_out()

        this.getFileList_ip()
        this.getFileList_all_local()
        this.getFileList_all_out()
        this.getFileList_all_ip()
        this.getFileList_all_prebl()
        this.getFileList_all_ipprebl()
        this.getFileList_all_smtprebl()

    },
    methods: {
        tan_smtp_ip(){
            this.tanchu=true;
            this.ip_smtp='';
        },
        
          //smtp 频率管控删除
        handleClick_base_smtp_default(index, scope) {
            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ip = scope.IP;

                    this.$axios
                        .get("/api/adm/cgi/bspam.cgi", {
                            params: {
                                __mode: "del_smtp_ip_nolimit",
                                sid: sid,

                                ip: ip,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_all_smtprebl()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        // 禁止IP发信删除
        handleClick_base_ip_default(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ip = scope.IPPREBL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipprebl",
                                sid: sid,

                                ip: ip,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_all_ipprebl()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        // 禁止用户发信删除
        handleClick_base_user_default(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let email = scope.PREBL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_prebl",
                                sid: sid,

                                email: email,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_all_prebl()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        // ip控制删除
        handleClick_ip_default(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ip = scope.IPCONTROL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ip_control",
                                sid: sid,

                                ip: ip,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_all_ip()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        //ip控制编辑
        edit_ip_default(index, scope) {
            this.tanchu_edit = true;
            this.loading = true

            // console.log(index, scope);
            this.ip = scope.IPCONTROL
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_ip_control",
                        sid: sid,
                        ip: this.ip

                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false
                        this.MaxIpConn_1 = res.data.ret.MaxIpConn_1
                        this.MaxIpConn_24 = res.data.ret.MaxIpConn_24
                        this.MaxIpMsg_1 = res.data.ret.MaxIpMsg_1
                        this.MaxIpMsg_24 = res.data.ret.MaxIpMsg_24
                        this.MaxIpRcpt_1 = res.data.ret.MaxIpRcpt_1
                        this.MaxIpRcpt_24 = res.data.ret.MaxIpRcpt_24

                    }
                })
        },
        off_edit_ip_default() {
            this.tanchu_edit = false;
        },
        // ip控制编辑保存
        save_edit_ip_default() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_ip_control",
                sid: sid,
                newadd: 0,
                MaxIpConn_24: this.MaxIpConn_24,
                MaxIpMsg_24: this.MaxIpMsg_24,
                MaxIpRcpt_24: this.MaxIpRcpt_24,
                MaxIpConn_1: this.MaxIpConn_1,
                MaxIpMsg_1: this.MaxIpMsg_1,
                MaxIpRcpt_1: this.MaxIpMsg_1,

                ip: this.ip,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList1();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.loading = false;
                        this.getFileList_ip();
                        this.tanchu_edit = false;
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
                
        },
        // 外部控制删除
        handleClick_out_default(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let email = scope.OUTEMAIL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_out_user_control",
                                sid: sid,

                                email: email,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_all_out()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        //外部控制编辑
        edit_out_default(index, scope) {
            this.tanchu_edit = true;
            // this.loading = true

            // console.log(index, scope);
            this.email = scope.OUTEMAIL
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_out_user_control",
                        sid: sid,
                        email: this.email

                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false

                        this.Foreignrcptnum = res.data.ret.Foreignrcptnum
                        this.MaxForeignMsg_1 = res.data.ret.MaxForeignMsg_1
                        this.MaxForeignRcpt_1 = res.data.ret.MaxForeignRcpt_1
                        this.MaxForeignMsg_24 = res.data.ret.MaxForeignMsg_24
                        this.MaxForeignRcpt_24 = res.data.ret.MaxForeignRcpt_24

                    }
                })
        },
        off_edit_out_default() {
            this.tanchu_edit = false;
        },
        // 外部控制编辑保存
        save_edit_out1_default() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_out_user_control",
                sid: sid,
                newadd: 0,
                MaxForeignMsg_24: this.MaxForeignMsg_24,
                MaxForeignRcpt_24: this.MaxForeignRcpt_24,
                MaxForeignMsg_1: this.MaxForeignMsg_1,
                MaxForeignRcpt_1: this.MaxForeignRcpt_1,
                Foreignrcptnum: this.Foreignrcptnum,

                email: this.email,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList1();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.loading = false;
                        this.getFileList_out();
                        this.tanchu_edit = false;
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
                
        },
        // 本地控制删除
        handleClick_loacl_default(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let email = scope.LOCALEMAIL;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_local_user_control",
                                sid: sid,

                                email: email,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_all_local()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        //本地控制编辑
        edit_loacl_default(index, scope) {
            this.tanchu_edit = true;
            // this.loading = true

            // console.log(index, scope);
            this.email = scope.LOCALEMAIL
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_local_user_control",
                        sid: sid,
                        email: this.email

                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false

                        this.MaxSenderBsRcpt_1 = res.data.ret.MaxSenderBsRcpt_1
                        this.MaxSenderBsRcpt_24 = res.data.ret.MaxSenderBsRcpt_24
                        this.MaxSenderDigestBsRcpt = res.data.ret.MaxSenderDigestBsRcpt
                        this.MaxSenderDigestMsg = res.data.ret.MaxSenderDigestMsg
                        this.MaxSenderDigestRcpt = res.data.ret.MaxSenderDigestRcpt
                        this.MaxSenderOutMsg_1 = res.data.ret.MaxSenderOutMsg_1
                        this.MaxSenderOutMsg_24 = res.data.ret.MaxSenderOutMsg_24
                        this.MaxSenderOutRcpt_1 = res.data.ret.MaxSenderOutRcpt_1
                        this.MaxSenderOutRcpt_24 = res.data.ret.MaxSenderOutRcpt_24
                        this.rcptnum = res.data.ret.rcptnum

                    }
                })
        },
        off_edit_loacl_default() {
            this.tanchu_edit = false;
        },
        // 本地控制编辑保存
        save_edit_loacl1_default() {
           
            this.tanchu1 = false;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_local_user_control",
                sid: sid,
                newadd: 0,
                MaxSenderOutRcpt_24: this.MaxSenderOutRcpt_24,
                MaxSenderOutMsg_24: this.MaxSenderOutMsg_24,
                MaxSenderBsRcpt_24: this.MaxSenderBsRcpt_24,
                MaxSenderOutMsg_1: this.MaxSenderOutMsg_1,
                MaxSenderOutRcpt_1: this.MaxSenderOutRcpt_1,
                MaxSenderBsRcpt_1: this.MaxSenderBsRcpt_1,
                MaxSenderOutBytes_24: this.MaxSenderOutBytes_24,
                MaxSenderOutBytes_1: this.MaxSenderOutBytes_1,
                MaxSenderDigestMsg: this.MaxSenderDigestMsg,
                MaxSenderDigestRcpt: this.MaxSenderDigestRcpt,
                MaxSenderDigestBsRcpt: this.MaxSenderDigestBsRcpt,
                DomainMaxSenderOutRcpt_24: this.DomainMaxSenderOutRcpt_24,
                DomainMaxSenderOutMsg_24: this.DomainMaxSenderOutMsg_24,
                DomainMaxSenderBsRcpt_24: this.DomainMaxSenderBsRcpt_24,
                DomainMaxSenderOutBytes_24: this.DomainMaxSenderOutBytes_24,
                rcptnum: this.rcptnum,
                email: this.email,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList_all_local();
                        this.tanchu_edit = false;
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
                
        },

        off_ban_ip() {
            this.tanchu = false;
        },
        // smtp 频率管控
           save_smtp_ip() {
               this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/bspam.cgi", {
                    params: {
                        __mode: "save_smtp_ip_nolimit",
                        sid: sid,
                        ip: this.ip_smtp

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList_all_smtprebl()
                        this.tanchu = false;
                        // this.loading = false;
                      
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        save_ban_ip() {
            this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_ipprebl_list",
                        sid: sid,
                        ip: this.ip

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList_all_ipprebl()
                        this.tanchu = false;
                        // this.loading = false;
                      
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        tan_ban_ip() {
            this.tanchu = true
            this.ip = ''
        },
        off_ban_user() {
            this.tanchu = false;
        },
        save_ban_user() {
this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_prebl_list",
                        sid: sid,

                        email: this.email

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList_all_prebl()
                        this.tanchu = false;
                        // this.loading = false;
                       
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        tan_ban_user() {
            this.tanchu = true
            this.email = ''
        },
        off_ip_default() {
            this.tanchu = false;
        },
        save_ip1_default() {
this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_ip_control",
                        sid: sid,
                        load_dataok: this.load_dataok,
                        MaxIpConn_24: this.MaxIpConn_24,
                        MaxIpMsg_24: this.MaxIpMsg_24,
                        MaxIpRcpt_24: this.MaxIpRcpt_24,
                        MaxIpConn_1: this.MaxIpConn_1,
                        MaxIpMsg_1: this.MaxIpMsg_1,
                        MaxIpRcpt_1: this.MaxIpRcpt_1,
                        ip: this.ip

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList_all_ip()
                        this.tanchu = false;
                        // this.loading = false;
                      
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        save_ip_default() {
                this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_ip_dft_ctrl",
                        sid: sid,
                        data_loadok: this.load_dataok3,
                        MaxIpConn_24: this.MaxIpConn_24,
                        MaxIpMsg_24: this.MaxIpMsg_24,
                        MaxIpRcpt_24: this.MaxIpRcpt_24,
                        MaxIpConn_1: this.MaxIpConn_1,
                        MaxIpMsg_1: this.MaxIpMsg_1,
                        MaxIpRcpt_1: this.MaxIpRcpt_1,

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.loading = false;
                        this.getFileList_ip()
                        this.tanchu = false;

                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        tan_ip_default() {

            this.ip = ''
            this.tanchu = true

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_ip_default_ctrl",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.load_dataok3 = res.data.ret.ok
                        this.MaxIpConn_1 = res.data.ret.result.MaxIpConn_1;
                        this.MaxIpConn_24 = res.data.ret.result.MaxIpConn_24;
                        this.MaxIpMsg_1 = res.data.ret.result.MaxIpMsg_1;
                        this.MaxIpMsg_24 = res.data.ret.result.MaxIpMsg_24;
                        this.MaxIpRcpt_1 = res.data.ret.result.MaxIpRcpt_1;
                        this.MaxIpRcpt_24 = res.data.ret.result.MaxIpRcpt_24;

                    }
                })
        },
        off_outside_default() {
            this.tanchu = false;
        },
        save_outside1_default() {
this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_out_user_control",
                        sid: sid,
                        data_loadok: this.load_dataok2,
                        MaxForeignMsg_24: this.MaxForeignMsg_24,
                        MaxForeignRcpt_24: this.MaxForeignRcpt_24,
                        MaxForeignMsg_1: this.MaxForeignMsg_1,
                        MaxForeignRcpt_1: this.MaxForeignRcpt_1,
                        DomainMaxForeignMsg_24: this.DomainMaxForeignMsg_24,
                        DomainMaxForeignRcpt_24: this.DomainMaxForeignRcpt_24,
                        DomainMaxForeignMsg_1: this.DomainMaxForeignMsg_1,
                        DomainMaxForeignRcpt_1: this.DomainMaxForeignRcpt_1,
                        Foreignrcptnum: this.Foreignrcptnum,
                        email: this.email

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList_all_out()
                        this.tanchu = false;
                       
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        save_outside_default() {
            this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_out_dft_ctrl",
                        sid: sid,
                        data_loadok: this.load_dataok2,
                        MaxForeignMsg_24: this.MaxForeignMsg_24,
                        MaxForeignRcpt_24: this.MaxForeignRcpt_24,
                        MaxForeignMsg_1: this.MaxForeignMsg_1,
                        MaxForeignRcpt_1: this.MaxForeignRcpt_1,
                        DomainMaxForeignMsg_24: this.DomainMaxForeignMsg_24,
                        DomainMaxForeignRcpt_24: this.DomainMaxForeignRcpt_24,
                        DomainMaxForeignMsg_1: this.DomainMaxForeignMsg_1,
                        DomainMaxForeignRcpt_1: this.DomainMaxForeignRcpt_1,
                        Foreignrcptnum: this.Foreignrcptnum,

                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList_out()
                        this.tanchu = false;

                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        tan_outside_default() {
            this.email = ''
            this.tanchu = true

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_out_default_ctrl",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        this.load_dataok2 = res.data.ret.ok
                        this.DomainMaxForeignMsg_1 = res.data.ret.result.DomainMaxForeignMsg_1;
                        this.DomainMaxForeignMsg_24 = res.data.ret.result.DomainMaxForeignMsg_24;
                        this.DomainMaxForeignRcpt_1 = res.data.ret.result.DomainMaxForeignRcpt_1;
                        this.DomainMaxForeignRcpt_24 = res.data.ret.result.DomainMaxForeignRcpt_24;
                        this.Foreignrcptnum = res.data.ret.result.Foreignrcptnum;
                        this.MaxForeignMsg_1 = res.data.ret.result.MaxForeignMsg_1;
                        this.MaxForeignMsg_24 = res.data.ret.result.MaxForeignMsg_24;
                        this.MaxForeignRcpt_1 = res.data.ret.result.MaxForeignRcpt_1;
                        this.MaxForeignRcpt_24 = res.data.ret.result.MaxForeignRcpt_24;

                    }
                })
        },
        off_loacl_default() {
            this.tanchu = false;
        },
        save_loacl1_default() {
this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_local_user_control",
                        sid: sid,
                        load_dataok: this.load_dataok,
                        MaxSenderOutRcpt_24: this.MaxSenderOutRcpt_24,
                        MaxSenderOutMsg_24: this.MaxSenderOutMsg_24,
                        MaxSenderBsRcpt_24: this.MaxSenderBsRcpt_24,
                        MaxSenderOutMsg_1: this.MaxSenderOutMsg_1,
                        MaxSenderOutRcpt_1: this.MaxSenderOutRcpt_1,
                        MaxSenderBsRcpt_1: this.MaxSenderBsRcpt_1,
                        MaxSenderOutBytes_24: this.MaxSenderOutBytes_24,
                        MaxSenderOutBytes_1: this.MaxSenderOutBytes_1,
                        MaxSenderDigestMsg: this.MaxSenderDigestMsg,
                        MaxSenderDigestRcpt: this.MaxSenderDigestRcpt,
                        MaxSenderDigestBsRcpt: this.MaxSenderDigestBsRcpt,
                        DomainMaxSenderOutRcpt_24: this.DomainMaxSenderOutRcpt_24,
                        DomainMaxSenderOutMsg_24: this.DomainMaxSenderOutMsg_24,
                        DomainMaxSenderBsRcpt_24: this.DomainMaxSenderBsRcpt_24,
                        DomainMaxSenderOutBytes_24: this.DomainMaxSenderOutBytes_24,
                        rcptnum: this.rcptnum,
                        email: this.email,
                        newadd: 1,
                    },
                })
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.loading = false;
                        this.getFileList_all_local()
                        this.tanchu = false;

                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        save_loacl_default() {
                this.$save_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_dft_ctrl_inout",
                        sid: sid,
                        data_loadok: this.load_dataok,
                        MaxSenderOutRcpt_24: this.MaxSenderOutRcpt_24,
                        MaxSenderOutMsg_24: this.MaxSenderOutMsg_24,
                        MaxSenderBsRcpt_24: this.MaxSenderBsRcpt_24,
                        MaxSenderOutMsg_1: this.MaxSenderOutMsg_1,
                        MaxSenderOutRcpt_1: this.MaxSenderOutRcpt_1,
                        MaxSenderBsRcpt_1: this.MaxSenderBsRcpt_1,
                        MaxSenderOutBytes_24: this.MaxSenderOutBytes_24,
                        MaxSenderOutBytes_1: this.MaxSenderOutBytes_1,
                        MaxSenderDigestMsg: this.MaxSenderDigestMsg,
                        MaxSenderDigestRcpt: this.MaxSenderDigestRcpt,
                        MaxSenderDigestBsRcpt: this.MaxSenderDigestBsRcpt,
                        DomainMaxSenderOutRcpt_24: this.DomainMaxSenderOutRcpt_24,
                        DomainMaxSenderOutMsg_24: this.DomainMaxSenderOutMsg_24,
                        DomainMaxSenderBsRcpt_24: this.DomainMaxSenderBsRcpt_24,
                        DomainMaxSenderOutBytes_24: this.DomainMaxSenderOutBytes_24,
                        rcptnum: this.rcptnum,
                    },
                })
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.loading = false;
                        this.getFileList()
                        this.tanchu = false;

                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
        },
        tan_loacl_default() {
            this.email = ''
            this.tanchu = true

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_dft_ctrl_inout",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.load_dataok = res.data.ret.ok
                        this.MaxSenderOutRcpt_24 = res.data.ret.result.MaxSenderOutRcpt_24;
                        this.MaxSenderOutMsg_24 = res.data.ret.result.MaxSenderOutMsg_24;
                        this.MaxSenderBsRcpt_24 = res.data.ret.result.MaxSenderBsRcpt_24;
                        this.MaxSenderOutMsg_1 = res.data.ret.result.MaxSenderOutMsg_1;
                        this.MaxSenderOutRcpt_1 = res.data.ret.result.MaxSenderOutRcpt_1;
                        this.MaxSenderBsRcpt_1 = res.data.ret.result.MaxSenderBsRcpt_1;
                        this.MaxSenderOutBytes_24 = res.data.ret.result.MaxSenderOutBytes_24;
                        this.MaxSenderOutBytes_1 = res.data.ret.result.MaxSenderOutBytes_1;
                        this.MaxSenderDigestMsg = res.data.ret.result.MaxSenderDigestMsg;
                        this.MaxSenderDigestRcpt = res.data.ret.result.MaxSenderDigestRcpt;
                        this.MaxSenderDigestBsRcpt = res.data.ret.result.MaxSenderDigestBsRcpt;
                        this.DomainMaxSenderOutRcpt_24 = res.data.ret.result.DomainMaxSenderOutRcpt_24;
                        this.DomainMaxSenderOutMsg_24 = res.data.ret.result.DomainMaxSenderOutMsg_24;
                        this.DomainMaxSenderBsRcpt_24 = res.data.ret.result.DomainMaxSenderBsRcpt_24;
                        this.DomainMaxSenderOutBytes_24 = res.data.ret.result.DomainMaxSenderOutBytes_24;
                        this.rcptnum = res.data.ret.result.rcptnum;
                        // this.load_hind1 = res.data.ret.LOAD_HIND

                    }
                })
        },
        // 本地默认控制加载
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_local_user_default",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                         this.loading = false;
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                         this.loading = false;
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList = res.data.ret.datalist;
                        this.default_local1 = res.data.ret.MaxSenderOutRcpt_24;
                        this.default_local2 = res.data.ret.MaxSenderOutMsg_24;
                        this.default_local3 = res.data.ret.MaxSenderBsRcpt_24;
                        this.default_local4 = res.data.ret.MaxSenderOutMsg_1;
                        this.default_local5 = res.data.ret.MaxSenderOutRcpt_1;
                        this.default_local6 = res.data.ret.MaxSenderBsRcpt_1;
                        this.default_local7 = res.data.ret.MaxSenderOutBytes_24;
                        this.default_local8 = res.data.ret.MaxSenderOutBytes_1;
                        this.default_local9 = res.data.ret.MaxSenderDigestMsg;
                        this.default_local10 = res.data.ret.MaxSenderDigestRcpt;
                        this.default_local11 = res.data.ret.MaxSenderDigestBsRcpt;
                        this.default_local12 = res.data.ret.DomainMaxSenderOutRcpt_24;
                        this.default_local13 = res.data.ret.DomainMaxSenderOutMsg_24;
                        this.default_local14 = res.data.ret.DomainMaxSenderBsRcpt_24;
                        this.default_local15 = res.data.ret.DomainMaxSenderOutBytes_24;
                        this.default_local16 = res.data.ret.rcptnum;
                        this.load_hind1 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 本地默认控制加载
        getFileList_out() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_out_user_default",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    }  else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       this.loading = false;
                    }else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       this.loading = false;
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_outside = res.data.ret.datalist;
                        this.default_outside1 = res.data.ret.MaxForeignMsg_24;
                        this.default_outside2 = res.data.ret.MaxForeignRcpt_24;
                        this.default_outside3 = res.data.ret.MaxForeignMsg_1;
                        this.default_outside4 = res.data.ret.MaxForeignRcpt_1;
                        this.default_outside5 = res.data.ret.DomainMaxForeignMsg_24;
                        this.default_outside6 = res.data.ret.DomainMaxForeignRcpt_24;
                        this.default_outside7 = res.data.ret.DomainMaxForeignMsg_1;
                        this.default_outside8 = res.data.ret.DomainMaxForeignRcpt_1;
                        this.default_outside9 = res.data.ret.Foreignrcptnum;

                        this.load_hind2 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 本地默认控制加载
        getFileList_ip() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_ip_default",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                      if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    }else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                      this.loading = false;
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      this.loading = false;
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_ip = res.data.ret.datalist;
                        this.default_ip1 = res.data.ret.MaxIpConn_24;
                        this.default_ip2 = res.data.ret.MaxIpMsg_24;
                        this.default_ip3 = res.data.ret.MaxIpRcpt_24;
                        this.default_ip4 = res.data.ret.MaxIpConn_1;
                        this.default_ip5 = res.data.ret.MaxIpMsg_1;
                        this.default_ip6 = res.data.ret.MaxIpRcpt_1;

                        this.load_hind3 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 本地默认控制加载
        getFileList_all_local() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_all_local_user",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                   if(!res){
           
             this.loading = false;
            
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    }  else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                                   this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                                   this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_local_a = res.data.ret.datalist;

                        this.load_hind4 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 本地默认控制加载
        getFileList_all_out() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_all_out_user",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                      if(!res){
           
             this.loading = false;
            
          }
         else    if (!res.data.fmstatus) {
                        alert(res.data);
                    }else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                                    this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                                    this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_out_a = res.data.ret.datalist;

                        this.load_hind5 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 本地默认控制加载
        getFileList_all_ip() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_all_ip_control",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
           
             this.loading = false;
            
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                     this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_ip_a = res.data.ret.datalist;

                        this.load_hind6 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 禁止用户发信加载
        getFileList_all_prebl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_all_prebl",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
           
             this.loading = false;
            
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_base_user = res.data.ret.datalist;

                        this.load_hind7 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 禁止ip发信加载
        getFileList_all_ipprebl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_all_ipprebl",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                   if(!res){
           
             this.loading = false;
            
          }
         else    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_base_ip = res.data.ret.datalist;

                        this.load_hind8 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
          // smtp管控加载
        getFileList_all_smtprebl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/bspam.cgi", {
                    params: {
                        __mode: "load_smtp_ip_nolimit",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
           
             this.loading = false;
            
          }
         else    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList_smtp_ip = res.data.ret.datalist;

                        this.load_hind9 = res.data.ret.LOAD_HINT;

                    }
                })
                
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

.pop-up1 {
    position: fixed;
    // padding: 20px 0;
    width: 50%;
    height: 60vh;
    top: 10%;
    left: 25%;
    z-index: 101;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    background: white;

    border-radius: 4px;
    padding-bottom: 14px;

    //   margin-left: -12.5%;
    //   margin-top: -14%;
    .find-text {
        width: 310px;
    }
}

.pop-up2 {
    position: fixed;
    // padding: 20px 0;
    width: 50%;
    height: 50vh;
    top: 10%;
    left: 25%;
    z-index: 101;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    background: white;

    border-radius: 4px;
    padding-bottom: 14px;

    //   margin-left: -12.5%;
    //   margin-top: -14%;
    .find-text {
        width: 310px;
    }
}

.main {

    border: 2px solid #D2D7E6;

}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
    // line-height: 28px;
}
</style>
